// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_rZr","cls2":"ExportFormatModal-cls2_72c ExportFormatModal-cls1_rZr"};